import { IconButton } from '@material-ui/core';
import { WbTooltip } from '@agilelab/plugin-wb-platform';
import BuildIcon from '@material-ui/icons/Build';

interface StartupActionsButtonProps {
  openModal: () => void;
}

export const StartupActionsButton: React.FC<StartupActionsButtonProps> = ({
  openModal,
}) => {
  return (
    <WbTooltip title="View Startup Actions Status">
      <IconButton
        aria-label="startup-actions-status"
        onClick={openModal}
        color="primary"
      >
        <BuildIcon />
      </IconButton>
    </WbTooltip>
  );
};

export default StartupActionsButton;
